import Wreqr from 'backbone.wreqr';

export default new Wreqr.EventAggregator();
